"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorRequiredEnforcement = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var TwoFactorRequiredEnforcement = (0, _keyMirror.default)({
  NOT_REQUIRED: null,
  REQUIRED: null
});
exports.TwoFactorRequiredEnforcement = TwoFactorRequiredEnforcement;